//Esta query se utiliza para traer todos ls proyectos por usuarioId
export const proyectosByUsuarioIdCustom = `query ProyectosByUsuarioId(
    $usuarioId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProyectoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    proyectosByUsuarioId(
      usuarioId: $usuarioId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        usuarioId
        isEliminated
        resultados {
          items {
            id
            etapa
            resultado
            calificacion
            createdAt
            updatedAt
          }
          nextToken
        }        
        createdAt
        updatedAt
        usuarioProyectosId        
        __typename
      }
      nextToken
      __typename
    }
  }
`

export const getProyectosByOrganizacion = /* GraphQL */ `
  query ProyectosByOrganizacion($organizacionId: String!, $nextToken: String) {
    proyectosByOrganizacionId(
      organizacionId: $organizacionId,
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tipoEstructura
        nivelCurso
        asignaturas
        isEliminated
        usuario {          
          name
          email                    
          isActive          
        }      
        usuarioId
        resultados {
          items {
            id
            etapa
            resultado
            calificacion
            createdAt
            updatedAt
          }
          nextToken
        }                      
        createdAt
        updatedAt
        usuarioProyectosId        
        __typename
      }
      nextToken
    }
  }
`;

//Suscripcion para cuando se crea un proyecto
export const onCreateProyectoCustom = /* GraphQL */ `
  subscription OnCreateProyecto($filter: ModelSubscriptionProyectoFilterInput) {
    onCreateProyecto(filter: $filter) {
      id
      name
      tipoEstructura
      nivelCurso
      asignaturas      
      usuarioId
      resultados {
        items {
          id
          etapa
          resultado
          calificacion
          createdAt
          updatedAt
        }
        nextToken
      }                
      createdAt
      updatedAt
      usuarioProyectosId      
      __typename
    }
  }
`;

